import {
	ECountermeasureCategory,
	type TCountermeasure,
	type TSegment
} from '@safesystem/client-playbook-lib';
import IconX from '#lib/assets/x-mark.svg?raw';

import bib from '@safesystem/client-playbook-lib/dist/bibliography.json';
import footnotes from '@safesystem/client-playbook-lib/dist/footnotes.json';

// SECURITY: returns HTML rendered via `{@html}`, so only pass segments bundled in `@safesystem/client-playbook-lib`, never server or user input.

let bibIndex = 0;

// Per-render context so each panel gets its own category-scoped footnote numbering.
export const createFootnotes = () => {
	const footnoteIds: Record<ECountermeasureCategory, string[]> = {
		[ECountermeasureCategory.Foundational]: [],
		[ECountermeasureCategory.Enhancement]: [],
		[ECountermeasureCategory.Supplementary]: []
	};

	const renderSegment = (segment: TSegment, category: ECountermeasureCategory): string => {
		if (segment.kind === 'text') return segment.html;

		if (segment.kind === 'footnote') {
			const labels = segment.ids.map((id) => {
				if (!footnoteIds[category].includes(id)) footnoteIds[category].push(id);
				return footnoteIds[category].indexOf(id) + 1;
			});
			return `<sup class="footnoteRef">${labels.join(', ')}</sup>`;
		}

		const id = `bib-${bibIndex++}`;
		const items = segment.ids
			.map((ref) => (bib as Record<string, string>)[ref])
			.filter(Boolean)
			.map((item) => `<li>${item}</li>`)
			.join('');
		return (
			`<sup><button class="bibLink" popovertarget="${id}" popovertargetaction="show" type="button">${segment.ids.length > 1 ? 'refs' : 'ref'}</button></sup>` +
			`<div class="bibPopover" popover id="${id}">` +
			`<button class="bibClose" popovertarget="${id}" popovertargetaction="hide" type="button" aria-label="Close references">${IconX}</button>` +
			`<ul>${items}</ul>` +
			`</div>`
		);
	};

	const linkify = (segments: TCountermeasure, category: ECountermeasureCategory) =>
		segments.map((segment) => renderSegment(segment, category)).join('');

	const getFootnotes = (category: ECountermeasureCategory) =>
		footnoteIds[category].map((footnoteId) => (footnotes as Record<string, string>)[footnoteId]);

	return { linkify, getFootnotes };
};
